import { render, staticRenderFns } from "./CbsRecordCard.vue?vue&type=template&id=c2374388&scoped=true"
import script from "./CbsRecordCard.vue?vue&type=script&lang=js"
export * from "./CbsRecordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2374388",
  null
  
)

export default component.exports